var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":"个人中心"}}),_vm._v(" "),_c('van-swipe',{attrs:{"autoplay":3000}},_vm._l((_vm.images),function(image,index){return _c('van-swipe-item',{key:index},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(image),expression:"image"}]})])}),1),_vm._v(" "),_c('date-picker'),_vm._v(" "),_c('footerView')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eba0851","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/mine/mine.vue
// module id = null
// module chunks = 